import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface CircleSpinnerProps {
  size: number;
  className?: string;
  progress: number;
  color: string;
  strokeWidth?: number;
}

/*
 * Style.
 */

const StyledSvg = styled.svg`
  transform: rotate(-90deg);
`;

/*
 * Component.
 */

export const CircleSpinner: FC<CircleSpinnerProps> = (props) => {
  const radius = props.size / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeWidth = props.strokeWidth || 2;
  const size = props.size + strokeWidth;
  const progress = Math.max(0, props.progress);
  const remainingProgress = 100 - Math.min(progress, 100);

  return (
    <StyledSvg height={size} width={size} className={props.className}>
      <circle cx="50%" cy="50%" r={radius} fill="none" strokeWidth={strokeWidth} />
      <circle
        cx="50%"
        cy="50%"
        r={radius}
        fill="none"
        stroke={props.color}
        strokeWidth={strokeWidth}
        strokeDashoffset={(Math.ceil(remainingProgress) / 100) * circumference}
        strokeDasharray={circumference}
      />
    </StyledSvg>
  );
};
